import React from 'react';
import BookCard from './BookCard';
import Paging from "../../../layouts/page/Paging";

interface Book {
    bookId: number;
    bookTitle: string;
    coverImage: string;
    authorName?: string;
}

interface BookCardListProps {
    books: Book[] | undefined;
    moveToBook: (bookId: number) => void;
    formatTitle?: (title: string) => React.ReactNode;
    totalPages: number;
    currentPage: number;
    onPageChange: (page: number) => void;
    emptyMessage?: string;
}

const BookCardList: React.FC<BookCardListProps> = ({
    books,
    moveToBook,
    totalPages,
    currentPage,
    onPageChange,
    emptyMessage,
}) => {

    if (!books || books.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center py-16 gap-3">
                <p className="text-[#888] text-[15px] md:text-[13px]">{emptyMessage || "등록된 작품이 없습니다."}</p>
            </div>
        );
    }

    return (
        <div>
            <div className="grid grid-cols-4 md:grid-cols-2 gap-4 md:gap-3">
                {books.map((book) => (
                    <BookCard
                        key={book.bookId}
                        book={{
                            bookId: book.bookId,
                            bookTitle: book.bookTitle,
                            coverImage: book.coverImage,
                            authorName: book.authorName,
                        }}
                        onClick={moveToBook}
                    />
                ))}
            </div>

            <div className="mt-10">
                <Paging
                    totalPages={totalPages}
                    currentPage={currentPage}
                    type="book"
                    onPageChange={onPageChange}
                />
            </div>
        </div>
    );
};

export default BookCardList;
